export default {
	props: {
		/**
		 * The value of the input
		 */
		value: { type: [ String, Number, Object ] },
		/**
		 * The label used above the input element.
		 */
		label: { type: String, },
		/**
		 * Wether or not show a asterix after the label.
		 */
		isRequired: { type: Boolean },
		/**
		 * A optional description of the field under the label, above the input element.
		 */
		description: { type: String },
		/**
		 * A optional hint under the input element.
		 */
		hint: { type: String },
		/**
		 * If a validation message is passed it is shown under the input element and above the hint.
		 */
		validationMessage: { type: String },
		/**
		 * Makes the input element disabled.
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * Sets visual styling to be invalid.
		 */
		isInvalid: {
			type: Boolean,
			default: false,
		},
		/**
		 * The placeholder text when there is no value present.
		 */
		placeholder: { type: String },
		/**
		 * Padding left
		 */
		paddingLeft: { type: String, },
		/**
		 * Width of the element. Can be `100px, 100%, auto, etc...`
		 */
		width: {
			type: [String],
			default: '100%',
		},
		/**
		 * The Size property sets the size of the input. Available values: `small, medium`.
		 */
		size: {
			type: String,
			default: 'medium',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'small', 'medium' ].indexOf(value) !== -1;
			}
		},
	},
	computed: {
		getStyle() {
			return {
				width: this.width,
				paddingLeft: this.paddingLeft,
			};
		},
		inputListeners() {
			return {
				...this.$listeners,
				input: event => {
					this.$emit('input', event.target.value);
				},
				change: event => {
					this.$emit('change', event.target.value);
				}
			};
		},
		inputWrapperListeners() {
			return {
				...this.$listeners,
				input: value => {
					this.$emit('input', value);
				},
				change: value => {
					this.$emit('change', value);
				},
			};
		}
	},
	methods: {
		onInput(event) {
			/**
			 * Fired immediately when input value is changed.
			 * @event input
			 * @type {object}
			 */
			this.$emit('input', event.target.value);
		},
		onChange(event) {
			/**
			 * Fired when blur if value changed.
			 * @event change
			 * @type {object}
			 */
			this.$emit('change', event.target.value);
		},
		onFocus(event) {
			/**
			 * Fired when input gets focus.
			 * @event focus
			 * @type {object}
			 */
			this.$emit('focus', event);
		},
		onBlur(event) {
			/**
			 * Fired when input looses focus.
			 * @event blur
			 * @type {object}
			 */
			this.$emit('blur', event);
		}
	}
};
